<template>
  <div class="specs">
    <div class="page">
      <div class="title">
        <h1>
          {{ dadosApiServico.menu }}
          <span v-if="dadosApiServico.requestType === 'G'">GET</span>
          <span v-if="dadosApiServico.requestType === 'P'">POST</span>
          <span v-if="dadosApiServico.requestType === 'T'">PUT</span>
          <span v-if="dadosApiServico.requestType === 'D'">DELETE</span>
        </h1>
        <hr />
        <!-- <div class="custom-select">
          <select class="selectVersao" disabled>
            <option selected value="versao1">Versão 2.34</option>
          </select>
        </div> -->
      </div>
      <div class="corpoDocumentacao">
        <!-- Introdução -->
        <h4 class="mt-3">Introdução</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dadosApiServico.introducao }}</p>
        <!-- URL -->
        <h4 class="mt-2">Url</h4>
        <p class="mb-1">{{ dadosApiServico.url }}</p>
        <!-- Métodos -->
        <h4 class="mt-2">Método</h4>
        <p class="mb-1">{{ dadosApiServico.metodo }}</p>

        <!-- ENTRADA GET -->
        <div v-if="entradaGet.corpo.length > 0">
          <h4 class="mt-3">Parametros na URL (GET)</h4>
          <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="entradaGet"
            :saida="true" :linhaCodigo="linhaCodigoSaida" :rotaAtributo="[]" />

        </div>

        <!-- Header -->
        <div v-if="header.corpo.length > 0">
          <h4 class="mt-3">Header</h4>
          <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="header" :saida="true"
            :linhaCodigo="null" :rotaAtributo="[]" />

        </div>

        <!-- ENTRADA FORM -->
        <div v-if="entradaForm.corpo.length > 0">
          <h4 class="mt-3">Parametros enviados FORM</h4>
          <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="entradaForm"
            :saida="true" :linhaCodigo="null" :rotaAtributo="[]" />

        </div>

        <!-- Entrada -->
        <div v-if="entrada.corpo.length > 0">
          <h4 class="mt-3">Entrada</h4>
          <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="entrada" :saida="false"
            :linhaCodigo="linhaCodigoEntrada" :rotaAtributo="[]" />
        </div>


        <div v-if="entrada.corpo.length > 0">
          <div class="header-linha">
            <h4 class="mt-3 mb-2">Exemplo Código Entrada</h4>

           <div class="dropdown-container">
              <select id="doc-perfil" class="form-select" v-model="perfilSelecionada" >
                <option value="geral">Geral</option>
                <option
                  v-for="seg in segs"
                  :key="seg.nome"
                  :value="seg"
                >
                  {{ seg.nome }}
                </option>
              </select>
            </div>
          </div>

        <div ref="conteudoParaCopiar" class="code">
          <a @click="copiarConteudoEntrada" class="btn-copy" href="javascript:void(0)">
            <i class="fa fa-copy"></i>
          </a>

          <!-- Se houver segmentação selecionada e exemploTexto preenchido, mostra exemploTexto -->
          <template v-if="usarSample">
            <div v-if="this.dadosApiServico.tipo == 'R'" class="ml-0">{</div>
            <div v-for="(ln, idx) in linhasExemploSegmentacao" :key="'samp-'+idx" :class="[ln.tab]">
              {{ ln.texto }}
            </div>
            <div v-if="this.dadosApiServico.tipo == 'R'" class="ml-0">}</div>
          </template>

          <!-- Caso contrário, mantém o trecho original -->
          <template v-else>
            <div>{{ inicioLinhaCodigoEntrada }}</div>
            <div v-for="item in linhaCodigoEntrada" :key="item.index">
              <div v-if="item.tipo === 'O'">
                <div v-if="item.exibir === true" :class="[item.tab]"
                    @click="mostrarLinhaCodigo(linhaCodigoEntrada, item.id)">
                  <a href="javascript:void(0)">
                    <i class="fa fa-chevron-right me-1"></i>{{ item.texto }}
                  </a>
                </div>
              </div>
              <div v-if="item.tipo === 'C'">
                <div v-if="item.exibir === true" :class="[item.tab]">{{ item.texto }}</div>
              </div>
              <div v-if="item.tipo === 'X'">
                <div v-if="item.exibir === true" :class="[item.tab]">{{ item.texto }}</div>
              </div>
            </div>
            <div>{{ fimLinhaCodigoEntrada }}</div>
          </template>
        </div>

        </div>

        <h4 class="mt-4 mb-1">Retorno</h4>

        <!-- SAIDA BODY -->
        <div v-if="saidaBody.corpo.length > 0">
          <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="saidaBody"
            :saida="true" :linhaCodigo="linhaCodigoSaida" :rotaAtributo="[]" />
        </div>

        <!-- SAIDA -->
        <div v-if="saida.corpo.length > 0">
          <div v-if="retornoJsonFormatoLista == false">
            <ConsultaListaAtributoDocumentacao :tipoServico="dadosApiServico.tipo" :listaAtributo="saida" :saida="true"
              :linhaCodigo="linhaCodigoSaida" :rotaAtributo="[]" />
          </div>
        </div>

        <div v-if="saida.corpo.length > 0">
          <h4 class="mt-3 mb-2">Exemplo Código Retorno</h4>
          <div ref="conteudoParaCopiar" class="code">
            <a @click="copiarConteudoSaida" class="btn-copy" href="javascript:void(0)"><i class="fa fa-copy"></i></a>
            <div>{{ inicioLinhaCodigoSaida }}</div>
            <div v-for="item in linhaCodigoSaida" :key="item.index">
              <div v-if="item.tipo === 'O'">
                <div v-if="item.exibir === true" :class=[item.tab]
                  @click="mostrarLinhaCodigo(linhaCodigoSaida, item.id)"><a href="javascript:void(0)"> <i
                      class="fa fa-chevron-right me-1"></i>{{ item.texto }}</a></div>
              </div>
              <div v-if="item.tipo === 'C'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
              <div v-if="item.tipo === 'X'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
            </div>
            <div>{{ fimLinhaCodigoSaida }}</div>
          </div>
        </div>

        <div v-if="linhaCodigoErro.length > 0">
          <h4 class="mt-4 mb-1">Erros</h4>
          <div class="code">
            <div>{{ inicioLinhaCodigoSaidaPadrao }}</div>
            <div v-for="item in linhaCodigoErro" :key="item.index">
              <div v-if="item.tipo === 'O'">
                <div v-if="item.exibir === true" :class=[item.tab]
                  @click="mostrarLinhaCodigo(linhaCodigoErro, item.id)"><a href="javascript:void(0)">
                    <i class="fa fa-chevron-right me-1"></i>{{ item.texto }}</a></div>
              </div>
              <div v-if="item.tipo === 'C'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
              <div v-if="item.tipo === 'X'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
            </div>
            <div>{{ fimLinhaCodigoSaidaPadrao }}</div>
          </div>
        </div>

        <div v-if="linhaCodigoAlerta.length > 0">
          <h4 class="mt-4 mb-1">Avisos</h4>
          <div class="code">
            <div>{{ inicioLinhaCodigoSaidaPadrao }}</div>
            <div v-for="item in linhaCodigoAlerta" :key="item.index">
              <div v-if="item.tipo === 'O'">
                <div v-if="item.exibir === true" :class=[item.tab]
                  @click="mostrarLinhaCodigo(linhaCodigoAlerta, item.id)"><a href="javascript:void(0)"> <i
                      class="fa fa-chevron-right me-1"></i>{{ item.texto }}</a></div>
              </div>
              <div v-if="item.tipo === 'C'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
              <div v-if="item.tipo === 'X'">
                <div v-if="item.exibir === true" :class=[item.tab]>{{ item.texto }}</div>
              </div>
            </div>
            <div>{{ fimLinhaCodigoSaidaPadrao }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ConsultaListaAtributoDocumentacao from "./ConsultaListaAtributoDocumentacao.vue";

export default {
  name: "Documentacao",
  props: {
    grupo: String,
    nome: String,
    idServicoApi: String,

  },
  components: {
    ConsultaListaAtributoDocumentacao
  },
  data() {
    return {
      dadosApiServico: {},
      indexAtributo: 0,
      entradaGet: {
        corpo: []
      },
      header: {
        corpo: []
      },
      entradaForm: {
        corpo: []
      },
      entrada: {
        corpo: [],
        listaObjetos: [],
      },
      saida: {
        corpo: [],
        listaObjetos: [],
      },
      alerta: {
        corpo: [],
        listaObjetos: [],
      },
      erro: {
        corpo: [],
        listaObjetos: [],
      },
      saidaBody: {
        corpo: []
      },
      retornoJsonFormatoLista: false,
      inicioLinhaCodigoEntrada: "",
      fimLinhaCodigoEntrada: "",
      linhaCodigoEntrada: [],
      inicioLinhaCodigoSaida: "",
      fimLinhaCodigoSaida: "",
      inicioLinhaCodigoSaidaPadrao: "{",
      fimLinhaCodigoSaidaPadrao: "}",
      linhaCodigoSaida: [],
      linhaCodigoAlerta: [],
      linhaCodigoErro: [],
      mapCodigo: new Map(),
      menuAberto: null,
      exemploTexto: '',
      segs: [],
      perfilSelecionada: 'geral ',
      linhasExemploSegmentacao: []
        };
  },
  methods: {

    // Converte uma "linha" (string ou objeto {texto, tab}) em string
    lineToString(line) {
      if (line == null) return '';
      if (typeof line === 'string') return line;

      const txt = (line.texto != null) ? line.texto : line.text;
      const tab = (typeof line.tab === 'string')
        ? (Number((line.tab.match(/ml-(\d+)/)||[])[1]) || 0)
        : 0;
      const indent = '  '.repeat(tab);

      if (typeof txt === 'string') {
        // aplica indentação em todas as quebras
        return txt.split('\n').map(l => indent + l).join('\n');
      }
      if (typeof txt === 'object') {
        // se o texto for objeto, imprime JSON bonito e indenta
        try {
          const pretty = JSON.stringify(txt, null, 2);
          return pretty.split('\n').map(l => indent + l).join('\n');
        } catch (e) {
          return indent + String(txt);
        }
      }
      return indent + String(txt);
    },
    ensureJsonBraces(text) {
      if (!text) return '';
      var t = String(text).trim();
      // Se já começa com { ou [, não faz nada
      if (t[0] === '{' || t[0] === '[' || t[0] === '<') return t;
      // Caso contrário, embrulha com chaves
      return '{\n' + t + '\n}';
    },

    getEntradaTextToCopy() {
      // Quando o dropdown de segmentação estiver em uso
      if (this.usarSample) {
        var body = '';

        if (Array.isArray(this.linhasExemploSegmentacao) && this.linhasExemploSegmentacao.length > 0) {
          body = this.linhasExemploSegmentacao.map(this.lineToString).join('\n');
        }

        // Se NÃO for "geral" e o conteúdo é JSON (não XML), garante { ... }
        if (this.perfil !== 'geral' && this.codeLang === 'language-json') {
          body = this.ensureJsonBraces(body);
        }
        return body;
      }

      // Comportamento original (bloco clássico)
      var inicio = (this.inicioLinhaCodigoEntrada || '').toString();
      var fim = (this.fimLinhaCodigoEntrada || '').toString();

      var linhasVisiveis = (this.linhaCodigoEntrada || [])
        .filter(function(l){ return l && l.exibir === true; })
        .map(this.lineToString)
        .join('\n');

      return [inicio, linhasVisiveis, fim].filter(Boolean).join('\n');
    },
    async copiarConteudoEntrada() {
      const texto = this.getEntradaTextToCopy();
      if (!texto) return;

      try {
        await navigator.clipboard.writeText(texto);
      } catch (e) {
        // Fallback para navegadores antigos
        const ta = document.createElement('textarea');
        ta.value = texto;
        ta.style.position = 'fixed';
        ta.style.top = '-9999px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          document.execCommand('copy');
          // alertUtils.alertSuccess('Copiado!');
        } finally {
          document.body.removeChild(ta);
        }
      }
    },
    async copiarConteudoSaida() {
      var code = this.inicioLinhaCodigoSaida;
      if (this.dadosApiServico.tipo == "R") {
        code += this.obterDadosJsonSaida(this.dadosApiServico.atributos);
      } else {
        code += this.obterDadosSoapSaida(this.dadosApiServico.atributos);
      }
      code += this.fimLinhaCodigoSaida;
      navigator.clipboard.writeText(code);
    },
    obterDadoFormato(atributo) {
      if (atributo.formato == "A") {
        return "Alfanumérico";
      } else if (atributo.formato == "N") {
        return "Numérico";
      } else if (atributo.formato == "V") {
        return "Valor";
      } else if (atributo.formato == "O") {
        return "Objeto";
      }
      return atributo.formato;
    },
    isLupa(atributo) {
      if ((atributo.dominio == null || atributo.dominio == "") && (atributo.observacao == null || atributo.observacao == "")) {
        return false;
      } else {
        return true;
      }
    },
    ajustarAtributos(atributos) {
      for (let atributo of atributos) {
        atributo.index = this.indexAtributo;
        this.indexAtributo++;
        if (atributo.tipo == "O") {
          this.ajustarAtributos(atributo.hierarquia);
        }
      }
    },
    ajustarAtributo(tipoServico, atributo) {
      atributo.indexAtributo = atributo.index;
      atributo.nomeExibicao = tipoServico == "S" ? "<" + atributo.nome + ">" : atributo.nome;
      atributo.obrigatorio = atributo.obrigatorio == "S" ? "fa-solid fa-check" : "fa-solid fa-xmark";
      atributo.lupa = this.isLupa(atributo);
      atributo.formato = this.obterDadoFormato(atributo);
    },
    mostrarLinhaCodigo(linhaCodigo, id) {
      var show = this.mapCodigo.get(id) == true ? false : true;
      var executar = false;
      for (let linha of linhaCodigo) {
        if (executar) {
          linha.exibir = show;
          if (linha.index == "linhaCodigoFim-" + id) {
            executar = false;
          }
        } else if (linha.index == "linhaCodigoInicio-" + id) {
          executar = true;
        }
      }
      this.mapCodigo.set(id, show);
    },
    //-REST-//
    ajustarAtributosRest(atributos) {
      for (let atributo of atributos) {
        this.ajustarAtributo("R", atributo);
        if (atributo.tipo == "O") {
          this.ajustarAtributosRest(atributo.hierarquia);
        }
      }
    },
    carregarAtributos(entrada, objeto, atributos) {
      for (let atributo of atributos) {
        if (atributo.entrada == entrada) {
          this.ajustarAtributo("R", atributo);
          if (atributo.tipo == "O") {
            this.ajustarAtributosRest(atributo.hierarquia);
          }
          objeto.corpo.push(atributo);
        }
      }
    },
    addLinhaCodigo(linhaCodigo, tab, index, texto, tipo) {
      linhaCodigo.push({
        index: index,
        id: index.split("-")[1],
        tab: "ml-" + tab,
        texto: texto,
        tipo: tipo,
        exibir: true,
      });
    },
    ajustarLinhaCodigo(linhaCodigo) {
      var fecha = "";
      var indexFecha = null;
      for (let linha of linhaCodigo) {
        if (fecha == "") {
          if (linha.index == "linhaCodigo-" + linha.id) {
            linha.exibir = true;
          } else if (linha.index == "linhaCodigoInicio-" + linha.id) {
            linha.exibir = true;
            fecha = "linhaCodigoFim-" + linha.id;
            indexFecha = linha.id;
            this.mapCodigo.set(linha.id, true);
          }
        } else {
          if (linha.index == "linhaCodigoFim-" + indexFecha) {
            fecha = "";
            indexFecha = null;
          }
        }
      }
    },
    carregarJsonExemplo(entrada, linhaCodigo, tab, atributos) {
      var tabAux = tab + 1;
      var index = 0;
      for (let atributo of atributos) {
        if (atributo.entrada == entrada) {
          var textoFim = ',';
          if (atributos[index + 1] == null || atributos[index + 1].entrada != entrada) {
            textoFim = '';
          }
          if (atributo.tipo != "O") {
            this.addLinhaCodigo(
              linhaCodigo,
              tabAux,
              "linhaCodigo-" + atributo.index,
              '"' + atributo.nome + '": null' + textoFim,
              "C"
            );
          } else if (atributo.tipo == "O") {
            if (atributo.lista == "N") {
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoInicio-" + atributo.index,
                '"' + atributo.nome + '": {',
                "O"
              );
              this.carregarJsonExemplo(
                entrada,
                linhaCodigo,
                tabAux,
                atributo.hierarquia
              );
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoFim-" + atributo.index,
                "}" + textoFim,
                "X"
              );
            } else {
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoInicio-" + atributo.index,
                '"' + atributo.nome + '": [ {',
                "O"
              );
              this.carregarJsonExemplo(
                entrada,
                linhaCodigo,
                tabAux,
                atributo.hierarquia
              );
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoFim-" + atributo.index,
                "} ]" + textoFim,
                "X"
              );
            }
          }
        }
        index++;
      }
      this.ajustarLinhaCodigo(linhaCodigo);
    },
    carregarJsonExemploSaida(linhaCodigo, tab, atributos) {
      var tabAux = tab + 1;
      var index = 0;
      for (let atributo of atributos) {
        if (atributo.entrada == "S" ||
          atributo.entrada == "A" ||
          atributo.entrada == "W") {
          var textoFim = ',';
          if (index == (atributos.length - 1)) {
            textoFim = '';
          }
          if (atributo.tipo != "O") {
            this.addLinhaCodigo(
              linhaCodigo,
              tabAux,
              "linhaCodigo-" + atributo.index,
              '"' + atributo.nome + '": null' + textoFim,
              "C"
            );
          } else if (atributo.tipo == "O") {
            if (atributo.lista == "N") {
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoInicio-" + atributo.index,
                '"' + atributo.nome + '": {',
                "O"
              );
              this.carregarJsonExemploSaida(
                linhaCodigo,
                tabAux,
                atributo.hierarquia
              );
              this.addLinhaCodigo(
                linhaCodigo,
                tabAux,
                "linhaCodigoFim-" + atributo.index,
                "}" + textoFim,
                "X"
              );
            } else {
              if (atributo.nome != "_") {
                this.addLinhaCodigo(
                  linhaCodigo,
                  tabAux,
                  "linhaCodigoInicio-" + atributo.index,
                  '"' + atributo.nome + '": [ {',
                  "O"
                );
              } else {
                tabAux = tabAux - 1;
              }
              this.carregarJsonExemploSaida(
                linhaCodigo,
                tabAux,
                atributo.hierarquia
              );
              if (atributo.nome != "_") {
                this.addLinhaCodigo(
                  linhaCodigo,
                  tabAux,
                  "linhaCodigoFim-" + atributo.index,
                  "} ]" + textoFim,
                  "X"
                );
              }
            }
          }
        }
        index++;
      }
      this.ajustarLinhaCodigo(linhaCodigo);
    },
    obterDadosJsonSaida(atributos) {
      var json = "";
      var index = 0;
      var indexFim = atributos.length - 1;
      for (let atributo of atributos) {
        var textoFim = ', ';
        if (index == indexFim) {
          textoFim = '';
        }
        if (atributo.entrada == "S" || atributo.entrada == "A" || atributo.entrada == "W") {
          if (atributo.tipo != "O") {
            json += '"' + atributo.nome + '": null' + textoFim;
          } else {
            var jsonFilho = this.obterDadosJsonSaida(atributo.hierarquia);
            if (atributo.lista == "N") {
              json += '"' + atributo.nome + '": {' + jsonFilho + "}" + textoFim;
            } else {
              if (atributo.nome == "_") {
                json += jsonFilho;
              } else {
                json += '"' + atributo.nome + '": [{' + jsonFilho + "}]" + textoFim;
              }
            }
          }
        }
        index++;
      }
      return json;
    },
    //-X-//
    //-SOUP-//
    ajustarAtributosSoap(atributos) {
      for (let atributo of atributos) {
        this.ajustarAtributo("S", atributo);
        if (atributo.tipo == "O") {
          this.ajustarAtributosSoap(atributo.hierarquia);
        }
      }
    },
    carregarAtributosSoap(entrada, objeto, atributos) {
      for (let atributo of atributos) {
        if (atributo.entrada == entrada) {
          this.ajustarAtributo("S", atributo);
          if (atributo.tipo == "O") {
            this.ajustarAtributosSoap(atributo.hierarquia);
          }
          objeto.corpo.push(atributo);
        }
      }
    },
    addLinhaCodigoSoap(linhaCodigo, tab, index, texto, tipo) {
      linhaCodigo.push({
        index: index,
        id: index.split("-")[1],
        tab: "ml-" + tab,
        texto: texto,
        tipo: tipo,
        exibir: true,
      });
    },
    ajustarLinhaCodigoSoap(linhaCodigo) {
      var fecha = "";
      var indexFecha = null;
      for (let linha of linhaCodigo) {
        if (fecha == "") {
          if (linha.index == "linhaCodigo-" + linha.id) {
            linha.exibir = true;
          } else if (linha.index == "linhaCodigoInicio-" + linha.id) {
            linha.exibir = true;
            fecha = "linhaCodigoFim-" + linha.id;
            indexFecha = linha.id;
            this.mapCodigo.set(linha.id, true);
          }
        } else {
          if (linha.index == "linhaCodigoFim-" + indexFecha) {
            fecha = "";
            indexFecha = null;
          }
        }
      }
    },
    carregarSoapExemplo(entrada, linhaCodigo, tab, atributos) {
      var tabAux = tab + 1;
      for (let atributo of atributos) {
        if (atributo.entrada == entrada) {
          if (atributo.tipo != "O") {
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigo-" + atributo.index,
              "<" + atributo.nome + "></" + atributo.nome + ">",
              "C"
            );
          } else if (atributo.tipo == "O") {
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigoInicio-" + atributo.index,
              "<" + atributo.nome + ">",
              "O"
            );
            this.carregarSoapExemplo(
              entrada,
              linhaCodigo,
              tabAux,
              atributo.hierarquia
            );
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigoFim-" + atributo.index,
              "</" + atributo.nome + ">",
              "X"
            );
          }
        }
      }
      this.ajustarLinhaCodigoSoap(linhaCodigo);
    },
    carregarSoapExemploSaida(linhaCodigo, tab, atributos) {
      var tabAux = tab + 1;
      for (let atributo of atributos) {
        if (atributo.entrada != "E") {
          if (atributo.tipo != "O") {
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigo-" + atributo.index,
              "<" + atributo.nome + "></" + atributo.nome + ">",
              "C"
            );
          } else if (atributo.tipo == "O") {
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigoInicio-" + atributo.index,
              "<" + atributo.nome + ">",
              "O"
            );
            this.carregarSoapExemploSaida(
              linhaCodigo,
              tabAux,
              atributo.hierarquia
            );
            this.addLinhaCodigoSoap(
              linhaCodigo,
              tabAux,
              "linhaCodigoFim-" + atributo.index,
              "</" + atributo.nome + ">",
              "X"
            );
          }
        }
      }
      this.ajustarLinhaCodigoSoap(linhaCodigo);
    },
    obterDadosSoapSaida(atributos) {
      let xml = "";
      for (let atributo of atributos) {
        if (atributo.entrada != "E") {
          if (atributo.tipo != "O") {
            xml += `<${atributo.nome}></${atributo.nome}>`;
          } else {
            let xmlFilho = this.obterDadosSoapSaida(atributo.hierarquia);
            if (atributo.lista == "N") {
              xml += `<${atributo.nome}>${xmlFilho}</${atributo.nome}>`;
            } else {
              xml += `<${atributo.nome}>${xmlFilho}</${atributo.nome}>`;
            }
          }
        }
      }
      return xml;
    },
    validarRetornoJsonFormatoLista(atributos) {
      this.inicioLinhaCodigoSaida = "{";
      this.fimLinhaCodigoSaida = "}";
      for (let atributo of atributos) {
        if (atributo.entrada == "S" && atributo.nome == "_") {
          this.retornoJsonFormatoLista = true;
          this.inicioLinhaCodigoSaida = "[{";
          this.fimLinhaCodigoSaida = "}]";
          break;
        }
      }
    },

    //-X-//
    async carregarDados() {

      try {
        this.isLoading = true;
        const urlCompleta = `/massificados/corporativo/gerenciador-parceiros/portal-api/consultar-servico/` + `${this.idServicoApi}`;
        const response = await axios.get(urlCompleta);
        this.dadosApiServico = response.data;
        this.ajustarAtributos(this.dadosApiServico.atributos);
        const atributos = this.dadosApiServico.atributos;
        if (this.dadosApiServico.tipo == "R") {
          this.inicioLinhaCodigoEntrada = "{";
          this.fimLinhaCodigoEntrada = "}";
          this.validarRetornoJsonFormatoLista(atributos);
          this.carregarAtributos("G", this.entradaGet, atributos);
          this.carregarAtributos("H", this.header, atributos);
          this.carregarAtributos("F", this.entradaForm, atributos);
          this.carregarAtributos("E", this.entrada, atributos);
          this.carregarAtributos("S", this.saida, atributos);
          this.carregarAtributos("A", this.alerta, atributos);
          this.carregarAtributos("W", this.erro, atributos);
          this.carregarAtributos("B", this.saidaBody, atributos);
          this.carregarJsonExemplo("E", this.linhaCodigoEntrada, 0, atributos);
          this.carregarJsonExemploSaida(this.linhaCodigoSaida, 0, atributos);
          this.linhaCodigoAlerta = [];
          this.carregarJsonExemplo("A", this.linhaCodigoAlerta, 0, atributos);
          this.linhaCodigoErro = [];
          this.carregarJsonExemplo("W", this.linhaCodigoErro, 0, atributos);
        } else if (this.dadosApiServico.tipo == "S") {
          this.inicioLinhaCodigoEntrada = response.data.codigoXmlInicio;
          this.fimLinhaCodigoEntrada = response.data.codigoXmlFim;
          this.inicioLinhaCodigoSaida = response.data.codigoXmlInicioOut;
          this.fimLinhaCodigoSaida = response.data.codigoXmlFimOut;
          this.carregarAtributosSoap("E", this.entrada, atributos);
          this.carregarAtributosSoap("S", this.saida, atributos);
          this.carregarAtributosSoap("A", this.alerta, atributos);
          this.carregarAtributosSoap("W", this.erro, atributos);
          this.carregarSoapExemplo("E", this.linhaCodigoEntrada, 0, atributos);
          this.carregarSoapExemploSaida(this.linhaCodigoSaida, 0, atributos);
          this.linhaCodigoAlerta = [];
          this.carregarSoapExemplo("A", this.linhaCodigoAlerta, 0, atributos);
          this.linhaCodigoErro = [];
          this.carregarSoapExemplo("W", this.linhaCodigoErro, 0, atributos);
        }

        this.isLoading = false;
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        this.isLoading = false;
      }
    },
    async carregarSegmentacoes() {
      try {
        var url = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/' + encodeURIComponent(this.idServicoApi);
        var resp = await fetch(url);
        if (!resp.ok) return;
        var doc = await resp.json();

        var keys = ['segmentacaoServicoApi', 'segmentacoes', 'segmentacao-servico-api', 'segmentação-serviço-api'];
        var lista = [];
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          var v = doc && doc[k];
          if (Array.isArray(v)) { lista = v; break; }
        }
        this.segs = lista;

        // seleção inicial (opcional)
        var geral = 'geral';
        for (var j = 0; j < this.segs.length; j++) {
          var s = this.segs[j];
          var nome = (s && s.nome) ? String(s.nome).toLowerCase() : '';
          if (nome === 'geral padrão') { geral = s; break; }
        }
        if (geral) {
          this.perfilSelecionada = geral; // dispara o watch e preenche exemploTexto
        } else if (this.segs.length > 0) {
          this.perfilSelecionada = this.segs[0]; // primeira disponível
        } else {
          this.perfilSelecionada = '';
          this.exemploTexto = '';
        }
      } catch (e) {
        console.error('Erro ao carregar segmentações:', e);
      }
    },

    renderSampleLines() {
      this.linhasExemploSegmentacao = [];
      var txt = (this.exemploTexto || '').trim();
      if (!txt) return;

      if(txt.startsWith('<')){
        this.linhasExemploSegmentacao = this.renderSampleLinesXML(txt);
      } else {
        try {
          var parsed = JSON.parse(txt);
          var out = [];
          this._jsonToLines(parsed, 0, true, out);
          this.linhasExemploSegmentacao = out;
        } catch (e) {
          // se não for JSON válido, mostra como 1 linha simples
          this.linhasExemploSegmentacao = [{ tab: 'ml-0', texto: txt }];
        }
      }

      
    },

    _jsonToLines(val, tab, isRoot, out) {
      var t = Object.prototype.toString.call(val);

      if (t === '[object Object]') {
        if (!isRoot) out.push({ tab: 'ml-' + tab, texto: '{' });
        var keys = Object.keys(val);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          var v = val[k];
          var isLast = i === keys.length - 1;

          var vt = Object.prototype.toString.call(v);

          if (vt === '[object Object]') {
            out.push({ tab: 'ml-' + (tab + 1), texto: '"' + k + '": {' });
            this._jsonToLines(v, tab + 1, true, out);
            out.push({ tab: 'ml-' + (tab + 1), texto: '}' + (isLast ? '' : ',') });
          } else if (vt === '[object Array]') {
            out.push({ tab: 'ml-' + (tab + 1), texto: '"' + k + '": [' });
            this._arrayToLines(v, tab + 1, out);
            out.push({ tab: 'ml-' + (tab + 1), texto: ']' + (isLast ? '' : ',') });
          } else {
            out.push({
              tab: 'ml-' + (tab + 1),
              texto: '"' + k + '": ' + this._primitiveToText(v) + (isLast ? '' : ',')
            });
          }
        }
        if (!isRoot) out.push({ tab: 'ml-' + tab, texto: '}' });
      }

      else if (t === '[object Array]') {
        this._arrayToLines(val, tab, out);
      }

      else {
        out.push({ tab: 'ml-' + tab, texto: this._primitiveToText(val) });
      }
    },

    _arrayToLines(arr, tab, out) {
      for (var i = 0; i < arr.length; i++) {
        var v = arr[i];
        var isLast = i === arr.length - 1;
        var vt = Object.prototype.toString.call(v);

        if (vt === '[object Object]') {
          out.push({ tab: 'ml-' + tab, texto: '{' });
          this._jsonToLines(v, tab, true, out);
          out.push({ tab: 'ml-' + tab, texto: '}' + (isLast ? '' : ',') });
        } else if (vt === '[object Array]') {
          out.push({ tab: 'ml-' + tab, texto: '[' });
          this._arrayToLines(v, tab + 1, out);
          out.push({ tab: 'ml-' + tab, texto: ']' + (isLast ? '' : ',') });
        } else {
          out.push({
            tab: 'ml-' + tab,
            texto: this._primitiveToText(v) + (isLast ? '' : ',')
          });
        }
      }
    },

    _primitiveToText(v) {
      if (v === null) return 'null';
      var t = typeof v;
      if (t === 'string') return '"' + v + '"';
      if (t === 'number' || t === 'boolean') return String(v);
      return 'null';
    },

    renderSampleLinesXML(xmlString) {
      const lines = [];
      if (!xmlString) return lines;

      // Garante uma tag por linha: "<a><b>" -> "<a>\n<b>"
      xmlString = xmlString.replace(/>\s*</g, '>\n<').trim();
      const split = xmlString.split('\n');

      let level = 0;

      split.forEach(raw => {
        let line = (raw || '').trim();
        if (!line) return;

        // 1) Abertura + fechamento na MESMA linha: <tag>valor</tag>
        const isOpenCloseSameLine = /^<[^>]+>.*<\/[^>]+>\s*$/.test(line);

        // 2) Fechamento puro ou texto + fechamento: </tag>  |  valor</tag>
        const isClosing =
          !isOpenCloseSameLine &&
          ( /^<\/[^>]+>/.test(line) || /^.+<\/[^>]+>\s*$/.test(line) );

        // 3) Self-closing: <tag ... />
        const isSelfClosing = /^<[^>]+\/>\s*$/.test(line);

        // 4) Abertura pura: <tag ...>
        const isOpening =
          !isOpenCloseSameLine &&
          !isSelfClosing &&
          /^<[^\/!?][^>]*>\s*$/.test(line);

        // Se for fechamento, reduz o nível ANTES de imprimir
        if (isClosing) {
          level = Math.max(level - 1, 0);
        }

        lines.push({
          tab: 'ml-' + Math.max(level, 0),
          texto: line
        });

        // Se for abertura pura, aumenta o nível DEPOIS de imprimir
        if (isOpening) {
          level++;
        }

        // open+close na mesma linha e self-closing não mexem no level
      });

      return lines;
    }



  },
  computed: {
    usarSample() {
      return this.perfil !== 'geral' && (this.exemploTexto || '').trim().length > 0;
    },
    codeLang() {
      const t = (this.exemploTexto || '').trim();
      if (!t) return '';
      return t[0] === '<' ? 'language-xml' : 'language-json';
    }
  },

  watch: {
    idServicoApi: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.carregarSegmentacoes()
        if (newValue && newValue.descricao) {
          console.log("Descricao:", newValue.descricao);
        }
      },
    },

    perfilSelecionada(nova) {
      var texto = '';
      if (nova && typeof nova === 'object') {
        var exemplo = (nova.exemploRestXml) ? nova.exemploRestXml : '';
        var desc = (nova.descricao) ? nova.descricao : '';
        texto = exemplo || desc;
      }
      this.exemploTexto = texto;

      var self = this;
      this.$nextTick(function () {
        if (window.Prism && self.$refs.sampleBlock) {
          window.Prism.highlightAllUnder(self.$refs.sampleBlock.parentNode);
        }
      });
    },

    exemploTexto() {
      this.renderSampleLines();
    }
  },
  mounted() {
    this.carregarDados();
    setTimeout(() => {
      document.querySelector(".page").classList.add("show");
    }, 500);
  },

};
</script>
<style>
.header-linha {
  display: flex;
  align-items: center;
  /* alinha verticalmente o h4 e o select */
  justify-content: space-between;
  /* h4 à esquerda, dropdown à direita */
  gap: 16px;
  /* espaço entre eles */
}

.dropdown-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 270px !important;
  /* opcional: ajusta a largura do select */
}

.form-select {
  width: 100%;
  max-width: 270px;
  /* limite visual opcional */
}
</style>
